import React, { useRef, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import StrapiMedia from "../strapi-media"
import { useReadMoreButton, useSameHeightElements } from "../../hooks"

const StartHere = ({ data }) => {
  const [activeSlider, setActiveSlider] = useState(0)
  const startHere = useRef(null)

  useReadMoreButton(startHere, "Read More", "Read Less")
  useSameHeightElements(startHere, ".sh-content")
  useSameHeightElements(startHere, ".sh-title")

  if (!data) return <div></div>
  const {
    htmlTitle,
    htmlContent,
    htmlInspireTitle,
    htmlInspireContent,
    htmlOptionsTitle,
    htmlOptionsContent,
    htmlQuoteTitle,
    htmlQuoteContent,
    ceremonyLink,
    receptionLink,
    musicPackageLink,
    inspireLink,
    inspireImage,
    quoteImage,
    optionsImage,
  } = data

  const goLeft = () => {
    if (activeSlider <= 0) setActiveSlider(2)
    else setActiveSlider(activeSlider - 1)
  }

  const goRight = () => {
    if (activeSlider >= 2) setActiveSlider(0)
    else setActiveSlider(activeSlider + 1)
  }

  return (
    <section
      className="max-w-screen-reds-2xl w-full mx-auto pt-20 px-7"
      ref={startHere}
    >
      <div className="flex flex-row items-center mb-5 lg:pb-[60px]">
        <h3 className="font-cardo--64 lg:font-cardo--101 lg:mr-10 leading-none">
          Start Here
        </h3>
        <div className="hidden lg:inline-block">
          <StaticImage
            src="../../static/images/icon/arrow-home.svg"
            alt="arrow"
          />
        </div>
      </div>
      <div className="lg:flex flex-row justify-between">
        <div className="lg:w-1/4 lg:border-r sm:pr-10 lg:pr-10 py-3">
          <div dangerouslySetInnerHTML={{ __html: htmlTitle }}></div>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
        </div>
        <div className="lg:hidden text-right mt-10">
          <button onClick={goLeft} className="mr-5 cursor-pointer inline-block">
            <StaticImage
              src="../../static/images/icon/angle-arrow-left.svg"
              alt="arrow"
            />
          </button>
          <button onClick={goRight} className="cursor-pointer inline-block">
            <StaticImage
              src="../../static/images/icon/angle-arrow-right.svg"
              alt="arrow"
            />
          </button>
        </div>
        <div
          className={`${
            activeSlider === 0 ? "block" : "hidden"
          } lg:block lg:w-1/4 border-none lg:border-r lg:px-10 pt-3 relative lg:pb-24 opacity-in`}
        >
          <div
            className="sh-title"
            dangerouslySetInnerHTML={{ __html: htmlInspireTitle }}
          ></div>
          <span className="flex items-center justify-center mx-auto my-5">
            <StrapiMedia image={inspireImage} className="lg:w-full w-auto" />
          </span>
          <div
            className="sh-content"
            dangerouslySetInnerHTML={{ __html: htmlInspireContent }}
          ></div>
          <Link className="block underline font-bold mt-10" to={inspireLink}>
            GET INSPIRED
          </Link>
        </div>
        <div
          className={`${
            activeSlider === 1 ? "block" : "hidden"
          } lg:block lg:w-1/4 border-none lg:border-r lg:px-10 pt-3 relative pb-24 opacity-in`}
        >
          <div
            className="sh-title"
            dangerouslySetInnerHTML={{ __html: htmlOptionsTitle }}
          ></div>
          <span className="flex items-center justify-center mx-auto my-5">
            <StrapiMedia image={optionsImage} className="lg:w-full w-auto" />
          </span>

          <div
            className="sh-content"
            dangerouslySetInnerHTML={{ __html: htmlOptionsContent }}
          ></div>
          <Link className="block underline font-bold mt-10" to={ceremonyLink}>
            BROWSE CEREMONY MUSIC
          </Link>
          <Link className="block underline font-bold mt-2" to={receptionLink}>
            BROWSE RECEPTION MUSIC
          </Link>
        </div>
        <div
          className={`${
            activeSlider === 2 ? "block" : "hidden"
          } lg:block lg:w-1/4 border-none lg:border-r lg:px-10 pt-3 relative pb-24 opacity-in`}
        >
          <div
            className="sh-title"
            dangerouslySetInnerHTML={{ __html: htmlQuoteTitle }}
          ></div>
          <span className="flex items-center justify-center mx-auto my-5">
            <StrapiMedia image={quoteImage} className="lg:w-full w-auto" />
          </span>
          <div
            className="sh-content"
            dangerouslySetInnerHTML={{ __html: htmlQuoteContent }}
          ></div>
          <Link
            className="block underline font-bold mt-10"
            to={musicPackageLink}
          >
            PACKAGES BUILDER
          </Link>
        </div>
      </div>
      <div className="w-full border-b mt-20"></div>
    </section>
  )
}

export default StartHere
